import { Store } from '../models/stores/store.ts';
import GenerateQuery from '../models/helpers/generateQuery.ts';
import { BaseSearchParam } from '../models/searchParams/baseSearchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";

const StoresController = {
    getAll: () => {
        let url = `stores/0/100`
        return ApiClient.get(url);
    },
    get: (tableSearchParam: TableSearchParam, baseSearchParam: BaseSearchParam) => {
        let url = `stores/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateQuery(baseSearchParam)}`;
        return ApiClient.get(url);
    },
    getByID: (id: number) => {
        return ApiClient.get(`store/${id}`);
    },
    post: (store: Store) => {
        return ApiClient.post('store', store);
    },
    put: (store: Store) => {
        return ApiClient.put(`store/${store.storeID}`, store);
    },
    delete: (id: number) => {
        return ApiClient.delete(`store/${id}`)
    }
};
export default StoresController;